import utilities from './utilities/index.js';
import essManagement from './ess/essManagement.js';
import salaryStructure from './salaryStructure/salaryStructure.js'
import processfnf from './fnf/processfnf.js'
import employeeexits from './exits/employeeexits.js'
import employeeDirectory from './ess/employeeDirectory.js';
import employeeDocument from './ess/employeeDocument.js';

export default {
    namespaced: true,
    modules: {
        employeeDirectory: employeeDirectory,
        employeeDocument: employeeDocument,
        essManagement: essManagement,
        salaryStructure: salaryStructure,
        utilities: utilities,
        processfnf:processfnf,
        employeeexits:employeeexits,
    }
}
